<template>
  <div id="footer">
    <v-container>
      <v-row justify="center" class="mt-5">
        <v-col md="12">
          <div class="wrapper">
            <div>
              <div class="logo tw-border-collapse">
                <img src="/images/logo-white.svg" alt="ภาษีเจริญ" />
              </div>
              <span class="tw-w-full tw-text-center tw-text-xs tw-opacity-70"
                >V {{ appVersion.substring(0,7) }}</span
              >
            </div>

            <div class="address">
              <h6>บริษัท ศาลาแดง จำกัด</h6>
              <div style="display: flex">
                <p>
                  ชั้น 6 อาคาร Q House เพลินจิต 598 ถนนเพลินจิต แขวงลุมพินี
                  เขตปทุมวัน กรุงเทพฯ 10330
                </p>
              </div>
              <div style="display: flex">
                <div class="tw-mb-4 tw-flex">
                  <img
                    src="/images/icons/icon_phone.png"
                    class="tw-mr-3"
                    style="width: 14px"
                  />
                  <a href="tel:0 2663 7895" style="color: #ffffff"
                    >02 663 7895</a
                  >
                </div>
                <div
                  style="
                    width: 30px;
                    height: 30px;
                    position: relative;
                    top: -5px;
                    left: 10px;
                    overflow: hidden;
                    border-radius: 5px;
                  "
                >
                  <a href="https://lin.ee/c3p76dk" target="_blank">
                    <img
                      src="/images/icons/line.svg"
                      style="width: 25px; height: 25px"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { version } from "../../../package";

export default {
  name: "NavigationDrawer",
  data() {
    return {
      appVersion: version,
    };
  },
};
</script>

<style lang="scss">
#footer {
  background: #460000;
  color: #ffffff;

  .wrapper {
    display: flex;

    .logo {
      width: 50px;
      margin-right: 40px;
    }

    .address {
      h6 {
        font-size: 20px;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .wrapper {
      display: flex;

      .logo {
        width: 80px;
        margin-right: 20px;
      }

      .address {
        h6 {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
